import {useTranslation} from 'react-i18next'

const ThankYou = () => {
  const {t} = useTranslation()

  return (
    <div
      className='d-flex align-items-center justify-content-center px-4 py-10'
      style={{
        minHeight: '100vh',
        backgroundColor: '#f5f7f8',
      }}
    >
      <div
        className='bg-white rounded shadow-sm text-center p-6 p-md-10 w-100'
        style={{
          maxWidth: '700px',
          borderTop: '4px solid #124956',
        }}
      >
        {/* Logo */}
        <div className='mb-5'>
          <img
            src='/media/logo/horizon-logo.png'
            alt='Horizon Genève'
            style={{
              width: '180px',
              maxWidth: '100%',
              height: '80px',
              objectFit: 'contain',
            }}
          />
        </div>

        {/* Organization */}
        <h2
          className='mb-6'
          style={{
            color: '#124956',
          }}
        >
          Horizon Genève
        </h2>
        <div
          className='d-flex align-items-center justify-content-center rounded-circle mx-auto mb-6'
          style={{
            width: '80px',
            height: '80px',
            backgroundColor: 'rgba(18, 73, 86, 0.10)',
          }}
        >
          <span
            className='fa fa-check'
            style={{
              color: '#124956',
              fontSize: '34px',
            }}
          />
        </div>
        <h1
          className='fw-bolder mb-4'
          style={{
            color: '#124956',
          }}
        >
          {t('EVENT.THANK_YOU_TITLE')}
        </h1>

        <p
          className='text-gray-700 fs-5 mb-0 mx-auto'
          style={{
            maxWidth: '650px',
            lineHeight: '1.8',
          }}
        >
          {t('EVENT.THANK_YOU_MESSAGE')}
        </p>

        <div
          className='mx-auto mt-7'
          style={{
            width: '60px',
            height: '3px',
            backgroundColor: '#124956',
            borderRadius: '5px',
          }}
        />
      </div>
    </div>
  )
}

export default ThankYou
